import * as _ from "lodash";

var BAD_PASSWORDS = require('../../../common/badPasswords.js');

/* Password policy:
 * - at least 8 characters
 * - require numbers
 * - require uppercase
 * - require lowercase
 * - require special characters
 * - no common words (e.g password)
 */

export enum PasswordPolicyItem {
    MIN_LENGTH = 'MIN_LENGTH',
    NUMBERS = 'NUMBERS',
    UPPERCASE = 'UPPERCASE',
    LOWERCASE = 'LOWERCASE',
    SPECIAL_CHARACTERS = 'SPECIAL_CHARACTERS',
    NO_COMMON_WORDS = 'NO_COMMON_WORDS'
}

export function checkPasswordPolicy(password: string) {
    var pass = [];
    var fail = [];

    if (password.length >= 8) pass.push(PasswordPolicyItem.MIN_LENGTH);
    else fail.push(PasswordPolicyItem.MIN_LENGTH);

    if (password.match(/[0-9]/)) pass.push(PasswordPolicyItem.NUMBERS);
    else fail.push(PasswordPolicyItem.NUMBERS);

    if (password.match(/[A-Z]/)) pass.push(PasswordPolicyItem.UPPERCASE);
    else fail.push(PasswordPolicyItem.UPPERCASE);

    if (password.match(/[a-z]/)) pass.push(PasswordPolicyItem.LOWERCASE);
    else fail.push(PasswordPolicyItem.LOWERCASE);

    if (password.match(/\W/)) pass.push(PasswordPolicyItem.SPECIAL_CHARACTERS);
    else fail.push(PasswordPolicyItem.SPECIAL_CHARACTERS);

    if (_.some(_.map(BAD_PASSWORDS, (p) => {
        return _.includes(password, p)
    }))) fail.push(PasswordPolicyItem.NO_COMMON_WORDS);
    else pass.push(PasswordPolicyItem.NO_COMMON_WORDS);

    return {pass, fail};
}


// WEBPACK FOOTER //
// ./srv/public/js/common/passwords.ts